var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAlertOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconAlertOutline"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 5311",
    x: 1.75,
    y: 1.75,
    width: 12.5,
    height: 12.5,
    rx: 6.25,
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 12",
    d: "M8 4.66699L8 8.66699",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 5312",
    x: 7.08337,
    y: 10.25,
    width: 1.83333,
    height: 1.83333,
    rx: 0.916667,
    fill: "#F89500"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlertOutline);
export default __webpack_public_path__ + "static/media/iconAlertOutline.e4fe381c9a8bf9f9b072c36220c092ae.svg";
export { ForwardRef as ReactComponent };